 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER101EMBARRASSMENT from '@/components/0_chapter101embarrassment'
 import A_CHAPTER102UPTHEMOUNTAINANDDOWNTHEMOUNTAIN from '@/components/1_chapter102upthemountainanddownthemountain'
 import A_CHAPTER103ARRIVINGATLAST from '@/components/2_chapter103arrivingatlast'
 import A_CHAPTER104INLET from '@/components/3_chapter104inlet'
 import A_CHAPTER105THEREISAKARSTCAVE from '@/components/4_chapter105thereisakarstcave'
 import A_CHAPTER106SLEEPINGTOGETHER from '@/components/5_chapter106sleepingtogether'
 import A_CHAPTER107ASHRIEK from '@/components/6_chapter107ashriek'
 import A_CHAPTER108SLEEPINGTOGETHERAGAIN from '@/components/7_chapter108sleepingtogetheragain'
 import A_CHAPTER109HARVESTINGRICE from '@/components/8_chapter109harvestingrice'
 import A_CHAPTER110DRINKALOTOFWINE from '@/components/9_chapter110drinkalotofwine'
 import A0_CHAPTER111ONTHEVILLAGEBOOKELECTIONPLAN from '@/components/10_chapter111onthevillagebookelectionplan'
 import A1_CHAPTER112KARSTCAVEDEVELOPMENTPLAN from '@/components/11_chapter112karstcavedevelopmentplan'
 import A2_CHAPTER113ELECTIONSUPPORTINGDOCUMENTS from '@/components/12_chapter113electionsupportingdocuments'
 import A3_CHAPTER114SPENDINGMONEYTOREPAIRTHEROAD from '@/components/13_chapter114spendingmoneytorepairtheroad'
 import A4_CHAPTER115TALKTOYOURACQUAINTANCES from '@/components/14_chapter115talktoyouracquaintances'
 import A5_CHAPTER116KONGSENSPARALYSISDUETOIMPACT from '@/components/15_chapter116kongsensparalysisduetoimpact'
 import A6_CHAPTER117KONGSHENWOKEUP from '@/components/16_chapter117kongshenwokeup'
 import A7_CHAPTER118PROMULGATEDMARRIAGE from '@/components/17_chapter118promulgatedmarriage'
 import A8_CHAPTER119CONVENTIONALMETHODOFTASTINGWINE from '@/components/18_chapter119conventionalmethodoftastingwine'
 import A9_CHAPTER120ACCOMPANYINGKONGMENGHAN from '@/components/19_chapter120accompanyingkongmenghan'
 import A0_CHAPTER121UPPERHOOK from '@/components/20_chapter121upperhook'
 import A1_CHAPTER122CONTESTMIXING from '@/components/21_chapter122contestmixing'
 import A2_CHAPTER123AGLASSOFBLUECHAMPAGNEFOREACHPERSON from '@/components/22_chapter123aglassofbluechampagneforeachperson'
 import A3_CHAPTER124GOHOMEAFTERTHEVICTORY from '@/components/23_chapter124gohomeafterthevictory'
 import A4_CHAPTER125THEUNREASONABLEREQUESTOFKONGMENGHAN from '@/components/24_chapter125theunreasonablerequestofkongmenghan'
 import A5_CHAPTER126REPEATEDAPOLOGIESFAILED from '@/components/25_chapter126repeatedapologiesfailed'
 import A6_CHAPTER127APPRECIATION from '@/components/26_chapter127appreciation'
 import A7_CHAPTER128FAKE from '@/components/27_chapter128fake'
 import A8_CHAPTER129PERSONALLYAPOLOGIZE from '@/components/28_chapter129personallyapologize'
 import A9_CHAPTER130HEMEETOLDPEOPLEINHISVILLAGE from '@/components/29_chapter130hemeetoldpeopleinhisvillage'
 import A0_CHAPTER131TAKEOUTEVIDENCE from '@/components/30_chapter131takeoutevidence'
 import A1_CHAPTER132BOATING from '@/components/31_chapter132boating'
 import A2_CHAPTER133EMERGENCYSITUATION from '@/components/32_chapter133emergencysituation'
 import A3_CHAPTER134SWIMBACKTOSHORE from '@/components/33_chapter134swimbacktoshore'
 import A4_CHAPTER135SAFEARRIVAL from '@/components/34_chapter135safearrival'
 import A5_CHAPTER136IMONMYWAYBACK from '@/components/35_chapter136imonmywayback'
 import A6_CHAPTER137ANALYSISOFTHEKILLERSORIGIN from '@/components/36_chapter137analysisofthekillersorigin'
 import A7_CHAPTER138LETTERSOFDISMISSAL from '@/components/37_chapter138lettersofdismissal'
 import A8_CHAPTER139ENCOUNTERINGBIGBOSSONTHEWAY from '@/components/38_chapter139encounteringbigbossontheway'
 import A9_CHAPTER140HAPPYTWOPEOPLE from '@/components/39_chapter140happytwopeople'
 import A0_CHAPTER141BEINGFOUNDOUT from '@/components/40_chapter141beingfoundout'
 import A1_CHAPTER142FINDTHERIGHTPLACE from '@/components/41_chapter142findtherightplace'
 import A2_CHAPTER143GETAKNIFESCAR from '@/components/42_chapter143getaknifescar'
 import A3_CHAPTER144TRUEDRY from '@/components/43_chapter144truedry'
 import A4_CHAPTER145LONGTIMENOSEE from '@/components/44_chapter145longtimenosee'
 import A5_CHAPTER146SCRATCHRICE from '@/components/45_chapter146scratchrice'
 import A6_CHAPTER147ASMALLCONTEST from '@/components/46_chapter147asmallcontest'
 import A7_CHAPTER148PERFECTCOMPETITION from '@/components/47_chapter148perfectcompetition'
 import A8_CHAPTER149PROPOSEAFRIENDLYRELATIONSHIPWITHYAOYAO from '@/components/48_chapter149proposeafriendlyrelationshipwithyaoyao'
 import A9_CHAPTER150COUSINBROTHERANDSISTER from '@/components/49_chapter150cousinbrotherandsister'
 import A0_CHAPTER151YAOYAOSFATHER from '@/components/50_chapter151yaoyaosfather'
 import A1_CHAPTER152LESSONRASCAL from '@/components/51_chapter152lessonrascal'
 import A2_CHAPTER153WAKINGUPFROMANIGHTMARE from '@/components/52_chapter153wakingupfromanightmare'
 import A3_CHAPTER154FOODSTRATEGY from '@/components/53_chapter154foodstrategy'
 import A4_CHAPTER155EXPLAINTOKONGMENGHAN from '@/components/54_chapter155explaintokongmenghan'
 import A5_CHAPTER156IMETAKNIFESCARAGAIN from '@/components/55_chapter156imetaknifescaragain'
 import A6_CHAPTER157RESOLVEGUCHANGFAN from '@/components/56_chapter157resolveguchangfan'
 import A7_CHAPTER158BEAUTYPILL from '@/components/57_chapter158beautypill'
 import A8_CHAPTER159ABOUTTHEPHARMACEUTICALFACTORY from '@/components/58_chapter159aboutthepharmaceuticalfactory'
 import A9_CHAPTER160HELPYOURLITTLESISTERGETBACKONHERFEET from '@/components/59_chapter160helpyourlittlesistergetbackonherfeet'
 import A0_CHAPTER161BRINGBACKABURDENSOME from '@/components/60_chapter161bringbackaburdensome'
 import A1_CHAPTER162HEHADSUCCESSFULLYREFINEDTHEFIRSTBEAUTYPELLET from '@/components/61_chapter162hehadsuccessfullyrefinedthefirstbeautypellet'
 import A2_CHAPTER163SELFACTINGKNIFE from '@/components/62_chapter163selfactingknife'
 import A3_CHAPTER164FIRSTEXPERIMENTER from '@/components/63_chapter164firstexperimenter'
 import A4_CHAPTER165HERMOTHERINLAWTRIEDBEAUTYPILL from '@/components/64_chapter165hermotherinlawtriedbeautypill'
 import A5_CHAPTER166ORGANIZEANAUCTION from '@/components/65_chapter166organizeanauction'
 import A6_CHAPTER167PERFECTEFFECT from '@/components/66_chapter167perfecteffect'
 import A7_CHAPTER168SHEWASCALLEDTOSCHOOLBYYAOYAO from '@/components/67_chapter168shewascalledtoschoolbyyaoyao'
 import A8_CHAPTER169WATCHRACE from '@/components/68_chapter169watchrace'
 import A9_CHAPTER170STIMULATIONPOINT from '@/components/69_chapter170stimulationpoint'
 import A0_CHAPTER171GAMEVICTORY from '@/components/70_chapter171gamevictory'
 import A1_CHAPTER172GETRIDOFTWOPEOPLEANDGOBACK from '@/components/71_chapter172getridoftwopeopleandgoback'
 import A2_CHAPTER173TRIAD from '@/components/72_chapter173triad'
 import A3_CHAPTER174FOURTHSTAGEOFTHEPROFOUNDART from '@/components/73_chapter174fourthstageoftheprofoundart'
 import A4_CHAPTER175RESULTOFSTIMULATINGTHEDOCTOR from '@/components/74_chapter175resultofstimulatingthedoctor'
 import A5_CHAPTER176DARKWAR from '@/components/75_chapter176darkwar'
 import A6_CHAPTER177STEPPOINT from '@/components/76_chapter177steppoint'
 import A7_CHAPTER178OPERATION007 from '@/components/77_chapter178operation007'
 import A8_CHAPTER179BOUNCE from '@/components/78_chapter179bounce'
 import A9_CHAPTER180TOOTHFORTOOTH from '@/components/79_chapter180toothfortooth'
 import A0_CHAPTER181DESIGNCOUNTERATTACK from '@/components/80_chapter181designcounterattack'
 import A1_CHAPTER182ESTABLISHMENTOFFIRSTGROUPPHARMACEUTICALINDUSTRY from '@/components/81_chapter182establishmentoffirstgrouppharmaceuticalindustry'
 import A2_CHAPTER183OPENINGCEREMONYINVITATION from '@/components/82_chapter183openingceremonyinvitation'
 import A3_CHAPTER184PARTURIENT from '@/components/83_chapter184parturient'
 import A4_CHAPTER185ONLYTHENDIDHEREMEMBERYAOYAO from '@/components/84_chapter185onlythendidherememberyaoyao'
 import A5_CHAPTER186AHOODLUMONASNACKSTREET from '@/components/85_chapter186ahoodlumonasnackstreet'
 import A6_CHAPTER187THEREAREALSOBARRICADES from '@/components/86_chapter187therearealsobarricades'
 import A7_CHAPTER188WELCOMECEREMONY from '@/components/87_chapter188welcomeceremony'
 import A8_CHAPTER189CHASEBYADOG from '@/components/88_chapter189chasebyadog'
 import A9_CHAPTER190HUMILIATEMAYOR from '@/components/89_chapter190humiliatemayor'
 import A0_CHAPTER191TALKTHINGSOVERINBED from '@/components/90_chapter191talkthingsoverinbed'
 import A1_CHAPTER192STRAIGHTTOTHECOUNTYMAGISTRATE from '@/components/91_chapter192straighttothecountymagistrate'
 import A2_CHAPTER193PROTECT from '@/components/92_chapter193protect'
 import A3_CHAPTER194PLANBACK from '@/components/93_chapter194planback'
 import A4_CHAPTER195ARTIFICIALACCIDENT from '@/components/94_chapter195artificialaccident'
 import A5_CHAPTER196DIRTYCHENLIGONG from '@/components/95_chapter196dirtychenligong'
 import A6_CHAPTER197AFTERDANGER from '@/components/96_chapter197afterdanger'
 import A7_CHAPTER198STRANGENEWS from '@/components/97_chapter198strangenews'
 import A8_CHAPTER199TOSEETHECAR from '@/components/98_chapter199toseethecar'
 import A9_CHAPTER200FACESMACKINGSALESPERSON from '@/components/99_chapter200facesmackingsalesperson'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter101embarrassment",
 			"name" : "0_chapter101embarrassment",
 			"component" : A_CHAPTER101EMBARRASSMENT
 		},
 		{
 			"path" : "/1_chapter102upthemountainanddownthemountain",
 			"name" : "1_chapter102upthemountainanddownthemountain",
 			"component" : A_CHAPTER102UPTHEMOUNTAINANDDOWNTHEMOUNTAIN
 		},
 		{
 			"path" : "/2_chapter103arrivingatlast",
 			"name" : "2_chapter103arrivingatlast",
 			"component" : A_CHAPTER103ARRIVINGATLAST
 		},
 		{
 			"path" : "/3_chapter104inlet",
 			"name" : "3_chapter104inlet",
 			"component" : A_CHAPTER104INLET
 		},
 		{
 			"path" : "/4_chapter105thereisakarstcave",
 			"name" : "4_chapter105thereisakarstcave",
 			"component" : A_CHAPTER105THEREISAKARSTCAVE
 		},
 		{
 			"path" : "/5_chapter106sleepingtogether",
 			"name" : "5_chapter106sleepingtogether",
 			"component" : A_CHAPTER106SLEEPINGTOGETHER
 		},
 		{
 			"path" : "/6_chapter107ashriek",
 			"name" : "6_chapter107ashriek",
 			"component" : A_CHAPTER107ASHRIEK
 		},
 		{
 			"path" : "/7_chapter108sleepingtogetheragain",
 			"name" : "7_chapter108sleepingtogetheragain",
 			"component" : A_CHAPTER108SLEEPINGTOGETHERAGAIN
 		},
 		{
 			"path" : "/8_chapter109harvestingrice",
 			"name" : "8_chapter109harvestingrice",
 			"component" : A_CHAPTER109HARVESTINGRICE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js